/**
 * Translates contest area to contest name
 *
 * @flow
 */
import green from "@material-ui/core/colors/green";
import lightgreen from "@material-ui/core/colors/lightGreen";
import cyan from "@material-ui/core/colors/cyan";
import yellow from "@material-ui/core/colors/yellow";
import blue from "@material-ui/core/colors/blue";
import purple from "@material-ui/core/colors/purple";
import orange from "@material-ui/core/colors/orange";
import teal from "@material-ui/core/colors/teal";
import pink from "@material-ui/core/colors/pink";
import amber from "@material-ui/core/colors/amber";

export const CONTEST_AREA = {
  NORTH_CENTRAL: {
    name: "North Central",
    color: lightgreen[500],
    colorHovered: lightgreen[600],
    abbr: "North-Central-North-America",
  },
  ROCKY_MOUNTAIN: {
    name: "Rocky Mountain",
    color: cyan[500],
    colorHovered: cyan[600],
    abbr: "Rocky-Mountain",
  },
  SOUTHERN_CALIFORNIA: {
    name: "Southern California",
    color: yellow[500],
    colorHovered: yellow[600],
    abbr: "Southern-California",
  },
  PACIFIC_NORTHWEST: {
    name: "Pacific Northwest",
    color: green[500],
    colorHovered: green[600],
    abbr: "PacNW",
  },
  SOUTH_CENTRAL: {
    name: "South Central",
    color: amber[500],
    colorHovered: amber[600],
    abbr: "SCUSA",
  },
  MID_CENTRAL: {
    name: "Mid Central",
    color: purple[500],
    colorHovered: purple[600],
    abbr: "Mid-Central-USA",
  },
  SOUTH_EAST: {
    name: "Southest USA",
    color: green[500],
    colorHovered: green[600],
    abbr: "Southeast-USA",
  },
  MID_ATLANTIC: {
    name: "Mid Atlantic USA",
    color: orange[500],
    colorHovered: orange[600],
    abbr: "Mid-Atlantic-USA",
  },
  EAST_CENTRAL: {
    name: "East Central",
    color: blue[500],
    colorHovered: blue[600],
    abbr: "East-Central-NA",
  },
  NORTHEASTERN: {
    name: "Northeastern",
    color: pink[500],
    colorHovered: pink[500],
    abbr: "northeast-north-america",
  },
  GREATER_NEW_YORK: {
    name: "Greater New York",
    color: teal[500],
    colorHovered: teal[600],
    abbr: "greater-new-york",
  },
};

export type ICPCContest = {
  abbr: string,
  name: string,
  color: string,
  colorHovered: string,
};

const nameToContestArea = {
  nc: CONTEST_AREA.NORTH_CENTRAL,
  rm: CONTEST_AREA.ROCKY_MOUNTAIN,
  socal: CONTEST_AREA.SOUTHERN_CALIFORNIA,
  pnw: CONTEST_AREA.PACIFIC_NORTHWEST,
  socen: CONTEST_AREA.SOUTH_CENTRAL,
  mc: CONTEST_AREA.MID_CENTRAL,
  se: CONTEST_AREA.SOUTH_EAST,
  ma: CONTEST_AREA.MID_ATLANTIC,
  ec: CONTEST_AREA.EAST_CENTRAL,
  ne: CONTEST_AREA.NORTHEASTERN,
  gny: CONTEST_AREA.GREATER_NEW_YORK,
};

export function toICPCContest(geographyProperty: Object): ICPCContest {
  // custom countries
  // we are using objects/hash maps to be faster than switch/ifs since this is evaluated on every iteration
  return (
    nameToContestArea[geographyProperty.contest_area] || {
      name: "",
      color: "#00000000",
      colorHovered: "#00000000",
      abbr: "undefined",
    }
  );
}
